import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioImageGroupComponent } from './components/radio-image-group.component';
import { FormsModule } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

@NgModule({
  declarations: [RadioImageGroupComponent],
  imports: [CommonModule, FormsModule, MatRadioModule],
  exports: [RadioImageGroupComponent],
})
export class RadioImageGroupModule {}
